export default __webpack_public_path__ + "static/apple-touch-icon-1be11ab630eea726c9266fbfbbed0a78.png";